export default function SafeArea({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      {children}
    </div>
  );
}
